// external packages
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';

// internal components
// import { CalendarInputComponent } from './calendar-input/calendar-input.component';
import { MultiselectInputComponent } from './multiselect/multiselect.component';
import { VirtualScrollComponent } from './virtual-scroll/virtual-scroll.component';

// internal directives
import { ClickOutsideEventDirective } from '../directives/click-outside-event/click-outside-event.directive';

@NgModule({
  declarations: [
    // CalendarInputComponent,
    MultiselectInputComponent,
    VirtualScrollComponent,
    ClickOutsideEventDirective],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollingModule
  ],
  exports: [
    // CalendarInputComponent,
    MultiselectInputComponent,
    VirtualScrollComponent]
})
export class NgxCustomComponentsModule { }
